/* eslint-disable */
// @ts-nocheck

import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { PhotoIcon } from '@heroicons/react/24/outline'

import { ImageLoad } from '../../../api/useServerMain'
import Modal from '../../modals/GenericModal'
import Button from '../Button'
import ImageComponent from './Image'
import MultipleDrop from './MultipleDrop'

interface MultiInterface {
  submit: Function
  className?: string
  previewDefault?: ImageLoad[]
  setDisabled?: Function
  fetching?: boolean
  disabled?: boolean
}

const FacebookStyleImages = ({
  className,
  previewDefault,
  submit,
  fetching,
  disabled,
}: MultiInterface) => {
  const { handleSubmit, control } = useForm()
  const [imageModal, setImageModal] = useState(false)
  const quant = previewDefault?.length ?? 0

  let component

  switch (quant) {
    case 0:
      component = (
        <div className="flex max-h-full w-full flex-col items-center p-8">
          <svg
            aria-hidden="true"
            className="m-auto flex rounded-md object-center text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 48 48"
          >
            <path
              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
            />
          </svg>
        </div>
      )
      break

    case 1:
      component = (
        <div className="flex max-h-full w-full flex-col items-center p-1">
          <ImageComponent
            className="flex h-full w-full items-center justify-center"
            hash={previewDefault![0].hash}
            src={previewDefault![0].src}
          />
        </div>
      )
      break

    case 2:
      component = (
        <div className="grid max-h-full w-full grid-cols-2 items-center gap-1 p-1">
          {previewDefault!.slice(0, 2).map((item, idx) => (
            <ImageComponent
              className="flex h-full w-full items-center justify-center"
              hash={item.hash}
              key={idx}
              src={item.src}
            />
          ))}
        </div>
      )
      break

    case 3:
      component = (
        <div className="flex max-h-full w-full flex-col items-center justify-center gap-1">
          <ImageComponent
            className="flex h-full w-full items-center justify-center"
            hash={previewDefault![0].hash}
            src={previewDefault![0].src}
          />
          {
            <div className="grid h-full grid-cols-2 items-center gap-1">
              {previewDefault!.slice(1).map((item, idx) => (
                <ImageComponent
                  className="flex h-full w-full items-center justify-center"
                  hash={item.hash}
                  key={idx}
                  src={item.src}
                />
              ))}
            </div>
          }
        </div>
      )
      break

    case 4:
      component = (
        <div className="grid max-h-full w-full grid-rows-2 gap-1">
          <div className="grid grid-cols-2 items-center gap-1">
            {previewDefault!.slice(0, 2).map((item, idx) => (
              <ImageComponent
                className="flex h-full w-full items-center justify-center"
                hash={item.hash}
                key={idx}
                src={item.src}
              />
            ))}
          </div>
          {
            <div className="grid h-full grid-cols-2 items-center gap-1">
              {previewDefault!.slice(2, 4).map((item, idx) => (
                <ImageComponent
                  className="h-full object-scale-down"
                  hash={item.hash}
                  key={idx}
                  src={item.src}
                />
              ))}
            </div>
          }
        </div>
      )
      break

    default:
      component = (
        <div className="flex max-h-full w-full flex-col gap-1">
          <div className="grid h-full grid-cols-2 items-center gap-1">
            {previewDefault!.slice(0, 2).map((item, idx) => (
              <ImageComponent
                className="flex h-full w-full items-center justify-center"
                hash={item.hash}
                key={idx}
                src={item.src}
              />
            ))}
          </div>
          <div className="relative grid h-full grid-cols-3 items-center gap-1">
            {previewDefault!.slice(2, 5).map((item, idx) => (
              <ImageComponent
                className="flex h-full items-center justify-center"
                hash={item.hash}
                key={idx}
                src={item.src}
              />
            ))}
            {quant > 5 && (
              <div className="absolute left-0 top-0 col-start-3 flex h-full w-full items-center justify-center bg-gray-400 bg-opacity-50">
                <h5 className="text-2xl font-bold text-white">{`+${
                  quant - 5
                }`}</h5>
              </div>
            )}
          </div>
        </div>
      )
      break
  }

  const afterSubmit: SubmitHandler<Record<string, any>> = (data) => {
    submit(data, () => setImageModal(false))
  }

  return (
    <>
      <div className={`${className ? className : ''} group relative`}>
        {component}
        <div className="absolute top-0 hidden h-full w-full flex-col items-center justify-center bg-gray-200 bg-opacity-70 p-1 group-hover:flex group-focus:flex">
          <PhotoIcon className="h-20 text-gray-500" />
          <h1
            className="cursor-pointer text-xl font-semibold text-gray-500 underline"
            onClick={!disabled ? () => setImageModal(true) : undefined}
          >
            Configurar imágenes
          </h1>
        </div>
      </div>

      {imageModal && (
        <Modal close={setImageModal} size="m" state={imageModal}>
          <form onSubmit={handleSubmit(afterSubmit)}>
            <MultipleDrop
              className="h-full rounded border border-dashed border-gray-400 p-2"
              control={control}
              name="images"
              previewDefault={previewDefault}
            />
            <div className="flex justify-end py-2">
              <Button
                color="slate-600"
                loading={fetching}
                name="Actualizar"
                type="submit"
              />
            </div>
          </form>
        </Modal>
      )}
    </>
  )
}

export default FacebookStyleImages
